import {Field} from './field';
import {cr} from 'fire-wind-water';

class Policy extends Field {
  constructor(field) {
    super(field);
    const attr = [
      'privacyPolicyUrl',
      'privacyPolicyUrlTitle',
      'privacyPolicyTitle',
      'privacyPolicyType',
      'isSelected'
    ];
    cr.each(attr, d => {
      this[d] = field[d];
    });

    this.displaySelectType = 'POLICY';
    this.isSelected = this.fieldInfo.isSelected == 1;
    this.privacyPolicyTitle = this.fieldInfo.privacyPolicyTitle.replace(/[\r\n]+/g, '@#$*%').split('@#$*%');
    this.displayType = 119;
    this.value = this.isSelected ? this.privacyPolicyUrl : null;
    this.setCustomError({
      key: 'privacyPolicy', message: '请阅读后确认',
      validator: (my) => {
        let isVaild = true;
        if(my.value !== my.privacyPolicyUrl){
          isVaild = false;
        }
        return isVaild;
      }
    });
    this.isError();
  }

  setValue(val) {
    this.isSelected = !!val;
    this.value = this.isSelected ? this.privacyPolicyUrl : null;
    this.dirty = true;
    this.isError();
  }

  initValue(val) {
    this.setValue(val);
    this.dirty = false;
  }

  clearValue() {
    this.isSelected = this.fieldInfo.isSelected == 1;
    this.value = this.isSelected ? this.privacyPolicyUrl : null;
    this.dirty = false;
    this.isError();
  }

  isError() {
    this.setError();
    this.hasError();
  }
}

export {Policy};
